import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import tools from "./utils/tools";
// import '@/permission';
import { scrollTo } from '@/utils/scroll-to';

// import '@/styles/index.scss';
import '@/styles/common.scss';
import './utils/rem.js'; //将px装换成rem
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
 
import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

Vue.prototype.$tools = tools;



//当前用户信息
Vue.prototype.$globalData = {
  currentUser: null
};
import GoEasy  from 'goeasy';
//创建全局GoEasy对象
Vue.prototype.goEasy = GoEasy;
const goEasy = GoEasy.getInstance({
  host: 'hangzhou.goeasy.io', //应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
  appkey: 'BC-4656807a8345491ba57e731f2291cb02', // common key,
  modules: ['im'],
});

Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;



// 地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '9abd1128580da3914b489937a310db31',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Map',
    'AMap.MouseTool',
    'mouseTool.polygon',
    'AMap.Polygon',
    'AMap.PolygonEditor',
    "AMap.Geolocation"
  ],
  v: '1.4.4',
})
let AMap = VueAMap;
Vue.use(AMap);
// 防止刷新地图不显示
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
amapKeys.forEach(key => {
  localStorage.removeItem(key)
})


//按钮防抖
Vue.directive("debounce", {
  inserted: function (el, binding) {
    let timer;
    el.addEventListener("click", () => {
      let a = el;
      if (!el.disabled) {
        el.style.cursor = "default";
      }
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        el.style.cursor = "pointer";
      }, 5000);
    });
  }
});



Vue.use(Element)

// router.beforeEach((to, from, next) => {
  // document.body.scrollTop = 1000
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0

  // window.scrollTo(0,0)
  // next()
// })


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
